import React, { useState } from "react";
import Grid from "@mui/material/Grid";
import lodash from "lodash";
import { colors } from "../../constants/colors";
import Paper from "@mui/material/Paper";
import PropTypes from "prop-types";
import { Typography } from "@mui/material";
import Divider from "@mui/material/Divider";
import PdfSign from "../../Images/pdf-sign.svg";
import CommonButton from "../CommonButton";
import FileUploadOutlinedIcon from "@mui/icons-material/FileUploadOutlined";
import { tableGridLabelsMapping } from "../../Utils/helper";
import CommonModal from "../Modal/CommonModal";
import { Box } from "@mui/system";
import PdfOpener from "../Modal/PdfOpener";
import { Fragment } from "react";
import { images } from "../../Images/Svg";
import { useSelector } from "react-redux";
import { typeOfAudio, typeOfPlayer } from "../../Utils/helper";
import AudioPlayer from "../Player/AudioPlayer";
import VideoPlayer from "../Player/VideoPlayer";
import CustomTooltip from "../CustomTooltip/CustomTooltip";
import { TIFFViewer } from "react-tiff";
import ReactPanZoom from "react-image-pan-zoom-rotate";
import DocxOpener from "../Modal/DocxOpener";

const { rightArrow } = images;

const fieldStyles = {
  color: colors?.gray,
  fontWeight: 400,
  fontSize: "11px",
  wordWrap: "break-word",
  textTransform: "capitalize",
};

const TableGrid = ({
  gridContent = {},
  label = "Documents",
  isDocument = false,
  forApprovalInvoices = false,
  backgroundColor,
  boxShadow,
  padding,
  rowSpacing,
  documentDetails = [],
  onClickDocument = () => {},
  onUploadButtonClick = () => {},
  xs = 2,
  InvestigationLabel,
  uploadButton = false,
  isVendorBlock = false,
  isButton = false,
  invoice = false,
  isCreateCase = false,
}) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedDoc, setSelectedDoc] = useState({});
  const truncateMiddleText = (str, maxLength) => {
    if (str?.length <= maxLength) {
      return str;
    }
    const firstPart = str?.substr(0, maxLength / 2);
    const lastPart = str?.substr(str?.length - maxLength / 2);
    return `${firstPart}.....${lastPart}`;
  };

  // let chargeEntries = Object.entries(gridContent?.["charge_details"] || {});
  let taxEntries = Object.entries(gridContent?.["tax_details"] || {});
  let charges = (gridContent?.["charge_details"] || [])?.map((item) => [
    item?.charge_name,
    item?.charge_amount,
  ]);
  let taxes =
    taxEntries?.length > 1 ? taxEntries?.slice(0, taxEntries?.length - 1) : [];

  gridContent = invoice
    ? {
        ...gridContent,
        charge_name: charges?.map((item) => item?.[0] || "-")?.join("\n"),
        charge_amount: charges?.map((item) => item?.[1] || "-")?.join("\n"),
        tax: taxes?.map((item) => item?.[0] || "-")?.join("\n"),
        tax_amount: taxes?.map((item) => item?.[1] || "-")?.join("\n"),
      }
    : gridContent;

  let caseSearchValue = useSelector((state) => state.SearchSlice.searchValue);

  const documentViewHandler = (docData) => {
    setIsModalOpen(true);
    setSelectedDoc({ ...docData });
  };

  const sortedGridContent = Object.keys(gridContent)?.sort((a, b) => {
    let gridContentKeys = Object.keys(gridContent);
    if (
      gridContentKeys.includes("policy_start_date") ||
      gridContentKeys.includes("charge_name")
    ) {
      return (
        Object.keys(tableGridLabelsMapping).indexOf(a) -
        Object.keys(tableGridLabelsMapping).indexOf(b)
      );
    } else {
      return 0;
    }
  });

  return (
    <Paper
      sx={{
        padding: padding ? padding : "0px 16px 16px 16px",
        boxShadow,
        backgroundColor,
      }}
      elevation={4}
    >
      {InvestigationLabel ? (
        <Typography
          sx={{ pl: "1.6rem", pt: "2rem", fontWeight: 600, fontSize: "1.3rem" }}
        >
          {InvestigationLabel}
        </Typography>
      ) : null}
      {isButton ? (
        <div
          style={{
            display: "flex",
            justifyContent: "center",
          }}
        >
          <CommonButton
            filledButton={true}
            label="Case found in Open Cases - View"
            endIcon={<img src={rightArrow} />}
            isEndIcon={true}
            fontSize="1.4rem"
            sx={{
              width: "auto",
              height: "3.5rem",
              lineHeight: "100%",
              marginTop: "6px",
            }}
            // onClick={addDescriptionHandlerClick}
          />
        </div>
      ) : null}
      <Grid
        container
        spacing={2}
        sx={{ margin: 0 }}
        rowSpacing={rowSpacing || rowSpacing === 0 ? rowSpacing : 3}
      >
        {Object.keys(gridContent).length ? (
          sortedGridContent?.map((item, index) => {
            let gridVal = "-";
            // if (gridContent[item]) {
            if (gridContent[item] === true) {
              gridVal = "Active";
            } else if (gridContent[item] === false) {
              gridVal = "In Active";
            } else if (lodash.isEmpty(gridContent[item]?.toString())) {
              gridVal = "-";
            } else if (typeof gridContent[item] === "object") {
              gridVal = "-";
            } else {
              gridVal = gridContent[item];
            }
            // }
            let gridValWithTooltip = (
              <CustomTooltip id={`${item}-${index}`} content={gridVal} />
            );
            return (isVendorBlock ||
              tableGridLabelsMapping[item] ||
              isCreateCase) &&
              item !== "documents" ? (
              <Grid item xs={xs} key={gridVal + index}>
                <Grid
                  container
                  sx={{ margin: 0 }}
                  rowSpacing={rowSpacing || rowSpacing === 0 ? rowSpacing : 1}
                >
                  <Grid item xs={12} sx={fieldStyles}>
                    <Grid item xs={12} sx={fieldStyles}>
                      {isVendorBlock || isCreateCase
                        ? `${item?.split("_")?.join(" ")}:`
                        : `${tableGridLabelsMapping[item]}:`}
                    </Grid>
                    <Grid
                      item
                      xs={8} //12
                      sx={{
                        color: "black",
                        fontWeight: 500,
                        fontSize: "12px",
                        wordWrap: "break-word",
                        marginTop: "5px",
                        whiteSpace:
                          item === "charge_name" ||
                          item === "charge_amount" ||
                          item === "tax" ||
                          item === "tax_amount"
                            ? "pre-line"
                            : "inherit",
                      }}
                    >
                      {caseSearchValue == gridVal ? (
                        <span className="highlight">
                          {gridVal?.toString()?.length > 0
                            ? gridValWithTooltip
                            : "-"}
                        </span>
                      ) : (
                        <>
                          {gridVal?.toString()?.length > 0
                            ? gridValWithTooltip
                            : "-"}
                        </>
                      )}

                      {(item === "charge_name" ||
                        item === "tax" ||
                        item === "charge_amount" ||
                        item === "tax_amount") && (
                        <Fragment>
                          <br />
                          <br />
                          {item === "charge_name" || item === "tax" ? (
                            <span style={fieldStyles}>Total:</span>
                          ) : item === "charge_amount" ? (
                            <span>{gridContent?.["charge_total"] || "-"}</span>
                          ) : item === "tax_amount" ? (
                            <span>
                              {gridContent?.["tax_details"]?.["total"] || "-"}
                            </span>
                          ) : (
                            ""
                          )}
                        </Fragment>
                      )}
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
            ) : null;
          })
        ) : (
          <div
            style={{
              margin: "20px 7px",
              display: "flex",
              width: "100%",
              justifyContent: "center",
              alignItems: "center",
              color: "grey",
            }}
          >
            <h3>No data</h3>
          </div>
        )}
      </Grid>
      {isDocument && (
        <>
          {forApprovalInvoices ? "" : <Divider sx={{ marginTop: 3 }} />}
          <Grid
            container
            spacing={1}
            sx={{ margin: "10px 0 0 0", paddingLeft: 1 }}
          >
            <Grid item xs={6}>
              <Typography
                sx={{
                  fontWeight: 600,
                  fontSize: "13px",
                  wordWrap: "break-word",
                }}
              >
                {label}
              </Typography>
            </Grid>
            <Grid
              item
              xs={6}
              sx={{
                display: "flex",
                justifyContent: "flex-end",
                paddingRight: "1.1rem",
              }}
            >
              {uploadButton && (
                <CommonButton
                  onClick={onUploadButtonClick}
                  isIcon
                  sx={{ width: "20%", height: "25px" }}
                  label="Upload"
                  fontSize={"1.2rem"}
                  endIcon={<FileUploadOutlinedIcon />}
                  isEndIcon={true}
                  isColor
                  removeBorder
                  isHover
                  hoverColor={"#E8505B"}
                  textColor="white"
                  backgroundColor={"#E8505B"}
                />
              )}
            </Grid>
            {/* Added by junaid flexWrap:"wrap"     marginBottom: "2rem",  */}
            <Grid item xs={12} sx={{ display: "flex", flexWrap: "wrap" }}>
              {documentDetails?.map((item, index) => (
                <Fragment key={`document_${index}`}>
                  <Grid
                    container
                    lg={2}
                    md={3}
                    sm={4}
                    xs={12}
                    sx={{
                      width: "17rem",
                      height: "4.2rem",
                      background: "#FAFAFA",
                      border: "1px solid #E8E8E8",
                      borderRadius: "4px",
                      marginRight: "4rem",
                      marginBottom: "2rem",
                      cursor: "pointer",
                    }}
                    key={item?.document_name}
                    onClick={() => documentViewHandler(item)}
                  >
                    <Grid item xs={2.5} sx={{ padding: "1rem" }}>
                      <img src={PdfSign} alt="pdf-sign" />
                    </Grid>
                    <Grid
                      item
                      xs={9.5}
                      sx={{ paddingTop: "0.8rem", paddingLeft: "0.5rem" }}
                    >
                      <span title={item?.document_name}>
                        <Typography
                          sx={{ fontSize: "1.2rem", lineHeight: "1.5rem" }}
                        >
                          {truncateMiddleText(item?.document_name, 10)}
                        </Typography>
                        <Typography sx={{ fontSize: "0.8rem" }}>
                          {item?.document_size}
                        </Typography>
                      </span>
                    </Grid>
                  </Grid>
                </Fragment>
              ))}
            </Grid>

            <CommonModal
              open={isModalOpen}
              showCrossIcon={true}
              width="50%"
              height="70%"
              onClose={() => {
                setIsModalOpen(false);
              }}
              downloadFilePath={selectedDoc?.document_path}
              fullsize={
                typeOfAudio?.includes(
                  selectedDoc?.document_name?.split(".")?.pop()
                )
                  ? false
                  : true
              }
            >
              <Box sx={{ marginTop: "5rem" }}>
                {selectedDoc?.document_name?.split(".")?.pop() === "pdf" ||
                selectedDoc?.document_name?.split(".")?.pop() === "PDF" ? (
                  <PdfOpener pdfFileLink={selectedDoc?.document_path} />
                ) : selectedDoc?.document_name?.split(".")?.pop() === "docx" ||
                  selectedDoc?.document_name?.split(".")?.pop() === "xlsx" ? (
                  <DocxOpener
                    fileName={selectedDoc?.document_path}
                    fileType={selectedDoc?.document_name?.split(".")?.pop()}
                  />
                ) : typeOfAudio?.includes(
                    selectedDoc?.document_name?.split(".")?.pop()
                  ) ? (
                  <AudioPlayer
                    src={selectedDoc?.document_path}
                    type={selectedDoc?.document_name?.split(".")?.pop()}
                  />
                ) : typeOfPlayer?.includes(
                    selectedDoc?.document_name?.split(".")?.pop()
                  ) ? (
                  <VideoPlayer
                    width="100%"
                    height="90%"
                    src={selectedDoc?.document_path}
                    type={selectedDoc?.document_name?.split(".")?.pop()}
                  />
                ) : selectedDoc?.document_name?.split(".")?.pop() === "tif" ? (
                  <TIFFViewer
                    tiff={selectedDoc?.document_path}
                    lang="en"
                    paginate="ltr"
                    buttonColor="#141414"
                  />
                ) : (
                  <div
                    style={{
                      position: "relative",
                      overflow: "hidden",
                    }}
                  >
                    <ReactPanZoom
                      alt={selectedDoc?.document_path}
                      image={selectedDoc?.document_path}
                    />
                  </div>
                )}
              </Box>
            </CommonModal>

            {/* <Grid item xs={2}>
            Doc 1
          </Grid>
          <Grid item xs={2}>
            Doc 2
          </Grid>
          <Grid item xs={2}>
            Doc 2{" "}
          </Grid>
          <Grid item xs={2}>
            Doc 3
          </Grid> */}
          </Grid>
        </>
      )}
    </Paper>
  );
};

TableGrid.propTypes = {
  gridContent: PropTypes.object,
  isDocument: PropTypes.bool,
};

export default TableGrid;
